interface DietaryTagsProps {
  readonly dietTypes?: string[];
  readonly allergies?: string[];
  readonly personName?: string;
  readonly className?: string;
}

function nextOccurrence(occurrences: Map<string, number>, value: string): number {
  const occurrence = occurrences.get(value) ?? 0;
  occurrences.set(value, occurrence + 1);
  return occurrence;
}

function DietaryTags({ dietTypes, allergies, personName, className = "" }: DietaryTagsProps) {
  if (!(dietTypes?.length || allergies?.length)) return null;

  const trimmedPersonName = personName?.trim();
  const dietOccurrences = new Map<string, number>();
  const allergyOccurrences = new Map<string, number>();

  return (
    <div className={className}>
      {trimmedPersonName && <span className="gcw:font-bold gcw:me-2">{trimmedPersonName}: </span>}
      {dietTypes?.map((type) => (
        <span
          key={`diet-${type}-${nextOccurrence(dietOccurrences, type)}`}
          className="gcw:inline-flex gcw:items-center gcw:rounded-full gcw:px-2 gcw:py-0.5 gcw:text-xs gcw:font-medium gcw:bg-gray-500 gcw:text-white gcw:me-1 gcw:mb-1"
        >
          {type}
        </span>
      ))}
      {allergies?.map((allergy) => (
        <span
          key={`allergy-${allergy}-${nextOccurrence(allergyOccurrences, allergy)}`}
          className="gcw:inline-flex gcw:items-center gcw:rounded-full gcw:px-2 gcw:py-0.5 gcw:text-xs gcw:font-medium gcw:bg-warning gcw:text-text-primary gcw:me-1 gcw:mb-1"
        >
          {allergy}
        </span>
      ))}
    </div>
  );
}

export default DietaryTags;
export type { DietaryTagsProps };
